<template>
  <PopoverMenu trigger="hover" placement="right-end" :auto-hide="false" data-test-id="navbar-menu-support">
    <template #trigger>
      <NavBarButton data-test-id="navbar-menu-support-button">
        <MoreIcon16 /> <template #title>{{ $t('menu.helpAndSupport') }}</template>
      </NavBarButton>
    </template>

    <template #items-list>
      <PopoverMenuSection>
        <PopoverMenuItem
          :primary-text="$t('projectDropdown.gettingStarted')"
          @click="() => $store.dispatch('onboarding/show', { restart: true })"
        />

        <PopoverMenuItem
          :primary-text="$t('projectDropdown.shortcuts')"
          @click="() => $store.dispatch('modal/show', { type: 'ShortcutCard', stackable: true, label: 'navbar' })"
          data-test-id="support-menu-shortcuts-button"
        />
      </PopoverMenuSection>
      <PopoverMenuSection :title="$t('projectDropdown.helpTitle')">
        <PopoverMenuItem
          :href="$t('projectDropdown.supportUrl')"
          target="_blank"
          :primary-text="$t('projectDropdown.support')"
        />

        <PopoverMenuItem
          :primary-text="$t('projectDropdown.feedback')"
          @click="showHelpscout"
          data-test-id="support-menu-helpscout-button"
        />

        <PopoverMenuItem
          :href="$t('projectDropdown.securityUrl')"
          target="_blank"
          :primary-text="$t('projectDropdown.security')"
        />

        <PopoverMenuItem
          :href="$t('projectDropdown.featuresUrl')"
          target="_blank"
          :primary-text="$t('projectDropdown.features')"
        />
      </PopoverMenuSection>

      <PopoverMenuSection divider>
        <CopyrightInfo />
      </PopoverMenuSection>
    </template>
  </PopoverMenu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { refresh, open, configPosition } from '@/helpscout';
import CopyrightInfo from '@components/CopyrightInfo.vue';
import MoreIcon16 from '@components/Icons/MoreIcon16.vue';
import NavBarButton from './NavBarButton.vue';

export default defineComponent({
  name: 'SupportMenu',

  components: {
    CopyrightInfo,
    MoreIcon16,
    NavBarButton,
  },

  props: {
    projectId: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      user: 'user/activityData',
      localConfig: 'user/localConfig',
      analyticsConsent: 'tracking/analyticsConsent',
    }),
  },

  methods: {
    showHelpscout() {
      // show the HelpScout beacon on the left if the Conversational AI is open
      if (this.localConfig.projects?.[this.projectId]?.isConversationalAiOpen) {
        configPosition('left');
      }

      refresh(this.user, null, this.analyticsConsent);
      open();
    },
  },
});
</script>
